/**
 * Parses a time string (e.g. "19:30") into its hour and minutes components.
 * Returns null when the format is unrecognised.
 */
export const parseTime = (
  time?: string
): { hour: number; minutes: number } | null => {
  if (!time) return null;
  const parts = time.split(":");
  if (parts.length < 2) return null;
  const hour = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  if (isNaN(hour) || isNaN(minutes)) return null;
  return { hour, minutes };
};

/**
 * Parses a time string (HH:MM) into total minutes since midnight.
 * Returns -1 for invalid input.
 */
export const parseTimeToMinutes = (time: string): number => {
  const parsed = parseTime(time);
  return parsed ? parsed.hour * 60 + parsed.minutes : -1;
};

/**
 * Parses a time string (e.g. "19:30") into its hour component.
 * Returns undefined when the format is unrecognised.
 */
export const parseHour = (time?: string): number | undefined => {
  const parsed = parseTime(time);
  return parsed ? parsed.hour : undefined;
};
